/**
 * Constructs a full asset URL based on the given relative path.
 * It uses the `PUBLIC_URL` environment variable as the base path if defined,
 * and ensures that there is exactly one slash between the base and the relative path.
 *
 * @param {string} relativePath - The relative path to the asset.
 * @returns {string} The fully resolved asset URL.
 */
export default function getAssetUrl(relativePath) {
  const base = process.env.PUBLIC_URL || '';
  const ret = `${base}/${relativePath}`.replace(/\/+/, '/');
  return ret;
}
